<script setup lang="ts">
import type { SimpleIcon } from 'simple-icons';

// Renders a simple-icons glyph. `color` switches between the brand's own hex
// (payment chips on a light tile) and currentColor (monochrome socials).
withDefaults(defineProps<{ icon: SimpleIcon; color?: 'brand' | 'current' }>(), { color: 'current' });
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    role="img"
    :aria-label="icon.title"
    :fill="color === 'brand' ? `#${icon.hex}` : 'currentColor'"
  >
    <path :d="icon.path" />
  </svg>
</template>
